export default "__VITE_ASSET___fK2vbWR__"